import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaBriefcase,
  FaShoppingCart,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const ShopifyEcommerceExpertsInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Shopify E-commerce Experts in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Boost Your Online Store</Subheading>}
        heading={
          <Heading>
            Shopify <span tw="text-primary-500">E-commerce Experts</span> in
            DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, our Shopify e-commerce experts in **Dubai
            International Financial Centre (DIFC)** deliver tailored solutions
            to create high-performing online stores. We combine Shopify
            expertise with DIFC’s business excellence to elevate your brand.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1556155092-490a1ba16284?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // E-commerce website on laptop
          "https://images.unsplash.com/photo-1661956602944-249bcd04b63f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Shopify logo and brand
          "https://images.unsplash.com/photo-1577401158266-39c8a0e37d58?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Online shopping experience
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Work with Experts"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Our Experts?</Subheading>}
        heading="Top Shopify Expertise in DIFC"
        description="We craft Shopify stores with precision and innovation."
        cards={[
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "Shopify Mastery",
            description: "Certified experts with deep platform knowledge.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Conversion Focus",
            description: "Layouts designed to drive sales and loyalty.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Custom Designs",
            description: "Unique stores that reflect your brand.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Delivery",
            description: "Quick setups for rapid market entry.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Optimized",
            description: "Seamless experiences across devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted in DIFC",
            description: "Preferred by DIFC’s top businesses.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Shopify Expert Process"
        description={
          <Description>
            We deliver Shopify excellence with a strategic approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Discovery: Understand your business and goals.</li>
              <li>Customization: Tailor Shopify themes and apps.</li>
              <li>Integration: Add payment gateways and tools.</li>
              <li>Testing: Ensure flawless performance.</li>
              <li>Launch: Go live with confidence.</li>
              <li>Support: Provide ongoing optimization.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1590935217180-77701fc6b476?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // E-commerce development process
          "https://images.unsplash.com/photo-1565106430482-8f6e74349ca1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Team working on digital projects
          "https://images.unsplash.com/photo-1523726491678-bf852e717f6a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Product photography for e-commerce
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Explore Our Process"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="Shopify Success in DIFC"
        description="Our expertise drives measurable results."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Surge",
            description: "Increased revenue for a DIFC retailer.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Growth",
            description: "Elevated visibility for an online store.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Trust",
            description: "High satisfaction from DIFC businesses.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Succeed?</Subheading>}
        heading="Shopify Experts in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset’s Shopify e-commerce experts in DIFC to
            build a powerful online store that stands out. Contact us today to
            start your journey!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplashWooCommerceDevelopmentServicesInDubai.js.com/photo-1516321165247-4aa89a48be28?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Successful business team
          "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Woman happily using laptop for online shopping
          "https://images.unsplash.com/photo-1561069934-eee225952461?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Dubai shopping experience
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Get Started Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
